/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Stop, PlayArrow } from '@material-ui/icons';
import * as ringSound from '~/assets/sounds';
import * as lib from '~/dependencies';
import { Container } from './styles';

export default function PlayTest({ speaker, type, deviceId }) {
  // STATES
  const [playSound, setPlaySound] = useState(false);

  // SELECTORS
  const ringToneSystem = useSelector(state => state?.system?.ringTone);
  const internalRingToneSystem = useSelector(
    state => state?.system?.internalRingtone
  );
  const speakerDevice = useSelector(
    state => state?.system?.deviceManager?.audio?.speaker
  );
  const ringDevice = useSelector(state => state?.system?.ringDevice);

  // HOOKS
  const { t } = lib.useTranslation();

  // MEMOS
  const ringToneSystemMemo = useMemo(() => ringToneSystem, [ringToneSystem]);
  const internalRingToneSystemMemo = useMemo(() => internalRingToneSystem, [
    internalRingToneSystem,
  ]);
  const ringDeviceMemo = useMemo(() => ringDevice?.deviceId, [ringDevice]);
  const speakerDeviceMemo = useMemo(() => speakerDevice?.deviceId, [
    speakerDevice,
  ]);

  // REFs
  const ringIncomming = useRef();

  // EFFECTS
  useEffect(() => {
    if (
      ringToneSystemMemo &&
      internalRingToneSystemMemo &&
      ringIncomming.current
    ) {
      ringIncomming.current.src =
        type === 'default'
          ? ringSound[ringToneSystemMemo]
          : ringSound[internalRingToneSystemMemo];
    }
  }, [ringToneSystemMemo, internalRingToneSystemMemo, type]);

  useEffect(() => {
    if (deviceId) {
      ringIncomming.current.setSinkId(deviceId);
    } else if (speaker && speakerDeviceMemo) {
      ringIncomming.current.setSinkId(speakerDeviceMemo);
    } else if (ringDeviceMemo && ringIncomming.current) {
      ringIncomming.current.setSinkId(ringDeviceMemo);
    }
  }, [ringDeviceMemo, speaker, speakerDeviceMemo, deviceId]);

  function playAudio(action) {
    setPlaySound(action);
    if (action && ringIncomming.current) {
      ringIncomming.current.play();
      setTimeout(() => {
        setPlaySound(false);
      }, 1500);
    }
  }

  return (
    <Container>
      <audio ref={ringIncomming} />

      {!playSound ? (
        <div
          className="btnControls"
          onClick={() => playAudio(true)}
          role="presentation">
          <span className="count">{t('components.playTest.play')}</span>
          <PlayArrow className="icon-play" />
        </div>
      ) : (
        <div
          className="btnControls"
          onClick={() => playAudio(false)}
          role="presentation">
          <span className="count">{t('components.playTest.playing')}</span>
          <Stop className="icon-stop" />
        </div>
      )}
    </Container>
  );
}

PlayTest.defaultProps = {
  speaker: false,
  type: 'default',
  deviceId: null,
};

PlayTest.propTypes = {
  speaker: lib.PropTypes.bool,
  type: lib.PropTypes.string,
  deviceId: lib.PropTypes.string,
};
